import CheckIcon from "@mui/icons-material/Check";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Button, IconButton } from "@mui/material";
import { Spin, Image } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import PsContext from "../../context";
import { useDialog } from "../../context/DialogContext";
import { cdnFileLink, CUSTOM_ICONS, formToObject } from "../../utils";
import {
  _UPDATE_PARTNER_BANK,
  _UPDATE_WHITE_LABEL,
} from "../../models/agenciesModel";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import ReactFileReader from "react-file-reader";
import { ServiceUrl } from "../../utils/serviceUrl";
import axios from "axios";

const WhiteLabel = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const { openDialog } = useDialog();
  const [checking, setChecking] = useState(false);

  const [domainName, setDomainName] = useState(
    props.dataSource.domain_name || "",
  );
  const [cnameStatus, setCnameStatus] = useState(null);
  const [isDomainCorrect, setIsDomainCorrect] = useState(false);
  const field = (fieldName) => props.dataSource[fieldName] || "";
  const [selectedFile, setSelectedFile] = useState("");
  const [oldFile, setOldFile] = useState(field("company_logo"));

  const getImage = () => {
    if (selectedFile && selectedFile.length > 0) return selectedFile;
    else if (oldFile && oldFile.length > 0) return cdnFileLink(oldFile);
    return CUSTOM_ICONS.NO_IMAGE.default;
  };

  const fileReaderChange = (file) => {
    console.log(file.fileList[0].type);
    var types = [
      "image/png",
      "image/jpeg",
      "image/JPEG",
      "image/jpg",
      "image/PNG",
      "image/JPG",
    ];
    if (!types.includes(file.fileList[0].type)) {
      openDialog({
        title: "Error",
        message: "Please select an Image with file extension .jpg or .png",
      });
      return;
    }

    if (file.fileList[0].size < 30000) {
      openDialog({
        title: "Error",
        message: "File size must greater than 30 kb",
      });
      return;
    }

    if (file.fileList[0].size > 300000) {
      openDialog({
        title: "Error",
        message: "File size must less than 300 kb",
      });
      return;
    }

    setSelectedFile(file.base64);
  };

  const clearFile = () => {
    if (!window.confirm("Do you want to remove ?")) return;
    setSelectedFile("");
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    setLoader(true);
    _UPDATE_WHITE_LABEL(formToObject(form)).then((res) => {
      if (res.status === "1") {
        context.setAlertMsg(res.message || "Updated");
        if (props.onSuccess) props.onSuccess();
      } else {
        openDialog({
          title: "Error",
          message: res.message || "Error on Update",
        });
      }
      setLoader(false);
    });
  };

  useEffect(() => {
    if (props.dataSource.domain_name) {
      checkCNAME();
    }
  }, []);

  // Function to check CNAME record
  const checkCNAME = async () => {
    if (!domainName) {
      setCnameStatus("Please enter a domain name.");
      setIsDomainCorrect(false);
      return;
    }
    setChecking(true);
    try {
      const response = await fetch(
        `https://dns.google/resolve?name=${domainName}&type=CNAME`,
      );
      const data = await response.json();
      const cnameRecord = data?.Answer?.[0]?.data;

      // Remove trailing dot and compare
      if (
        cnameRecord &&
        cnameRecord.replace(/\.$/, "") === "school.kalvisalai.in"
      ) {
        setCnameStatus(
          "✅ This domain is currently pointing to school.kalvisalai.in",
        );
        setIsDomainCorrect(true); // Enable Update button
      } else {
        setCnameStatus(
          "❌ Correct domain to be pointed is: school.kalvisalai.in",
        );
        setIsDomainCorrect(false); // Disable Update button
      }
    } catch (error) {
      setCnameStatus("⚠️ Unable to verify CNAME. Try again.");
      setIsDomainCorrect(false);
    }
    setChecking(false);
  };

  return (
    <Spin spinning={loader}>
      <Form
        method="post"
        noValidate
        validated={validated}
        onSubmit={handleFormSubmit}
      >
        <input type="hidden" name="id" value={field("id")} />
        <input type="hidden" name="company_logo" value={selectedFile} />

        <Form.Label>
          <strong>Upload your company logo:</strong>
        </Form.Label>

        {selectedFile && selectedFile.length > 0 && (
          <a className="img-close-btn" onClick={(e) => clearFile()}>
            x
          </a>
        )}

        <Image
          src={getImage()}
          fallback={CUSTOM_ICONS.NO_IMAGE.default}
          style={
            props.style || {
              width: "180px",
              cursor: "pointer",
              height: "190px",
              maxWidth: "100%",
            }
          }
          className="bg-white rounded p-2 shadow-sm"
        />

        <ReactFileReader
          base64={true}
          handleFiles={fileReaderChange}
          fileTypes={[".jpg", ".png", ".JPG", ".PNG"]}
        >
          <Button size="sm" type="button" className="btn-block">
            <i className="fa-solid fa-file-image me-2"></i>
            {selectedFile && selectedFile.length > 0
              ? "Change Image"
              : "Select Image"}
          </Button>
        </ReactFileReader>

        {/* White Label Instructions */}
        <Form.Group className="mb-3">
          <Form.Text
            as="div"
            style={{
              border: "1px solid #ddd",
              padding: "10px",
              borderRadius: "5px",
              backgroundColor: "#f9f9f9",
            }}
          >
            <p>
              You can use our <strong>Kalvi Salai</strong> portal (
              <a
                href="https://school.kalvisalai.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                school.kalvisalai.in
              </a>
              ) as your white-labeled branded portal.
            </p>
            <p>
              For example: <strong>www.yourcompany.com</strong> or{" "}
              <strong>www.school.yourcompany.com</strong>
            </p>
            <p>
              If you want this feature, please complete the following setup:
            </p>
          </Form.Text>
        </Form.Group>

        {/* Company Name Field */}
        <Row className="mt-3">
          <Col md={2}>
            <Form.Label>Your Company Name*</Form.Label>
          </Col>
          <Col md={3}>
            <Form.Control
              type="text"
              name="company_name"
              defaultValue={field("company_name")}
              required
            />
          </Col>
        </Row>

        <Row className="mt-3 align-items-center">
          <Col md={2}>
            <Form.Label>Domain Name*</Form.Label>
          </Col>
          <Col md={3}>
            <Form.Control
              type="text"
              name="domain_name"
              value={domainName}
              onChange={(e) => {
                setDomainName(e.target.value);
                setIsDomainCorrect(false);
                setCnameStatus(null);
              }}
              required
            />
          </Col>
          <Col md={1}>
            <Button onClick={checkCNAME} disabled={checking} variant="outlined">
              <AutorenewIcon />
            </Button>
          </Col>
          <Col md={6}>
            {cnameStatus && (
              <div
                style={{
                  marginTop: "10px",
                  color: cnameStatus.startsWith("✅") ? "green" : "red",
                }}
              >
                {cnameStatus}
              </div>
            )}
          </Col>
        </Row>

        <Row className="mt-4">
          <Col>
            <Button
              type="submit"
              variant="contained"
              startIcon={<CheckIcon />}
              disabled={!isDomainCorrect} // Disable button unless domain is correct
            >
              Update
            </Button>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default WhiteLabel;
